import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import Widget from "./Widgets";
import Section from "./Section";
import DashboardUpdates from "./DashboardUpdates";
import DashboardHighlights from "./DashboardHighlights";

const DashboardEcommerce = () => {
  document.title = "SSW Technologies Dashboard";
  const authData = JSON.parse(sessionStorage.getItem("authUser"));
  const userRole = authData?.role || "Employee";
  const [rightColumn, setRightColumn] = useState(true);
  const toggleRightColumn = () => setRightColumn(!rightColumn);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div style={{ padding: "0 4px" }}>
            <Section rightClickBtn={toggleRightColumn} />
            <Row>
              <Widget />
            </Row>
            <Row>
              <DashboardUpdates role={userRole} />
            </Row>
            <Row>
              <DashboardHighlights />
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardEcommerce;